import { MINIMIZE, AFTER_ACTIONS, CLOSE_CHAT_CONFIRMATION, RATING } from "../mutation-types";
import { log2 } from "../../utils/log2";
import { getCountryPhoneInfos } from "../../api/setting";

const log = log2("app.vuex");
const state = {
    minimized: false,
    showAfterActions: false,
    showRating: false,
    showCloseChatConfirmation: false,
    currentHostUrl: undefined,
    zoomValue: 1,
    mobileVersion: false,
    safari: false,
    current_socket: null,
    volume: 100,
    videoCallDialing: null,
    videoCallMode: false,
    currentVC: null,
    tabVisible: document.visibilityState === "visible",
    lastTabHiddenTS: null,
    previewMode: window.location.search.indexOf("preview") !== -1,
    visitingPage: null,
    pageIndex: 1,
    lastPageIndex: [],
    // Tetikleyici cevrimdisiyken sohbet baslatmak istedi: mesaji ticket formuna tasi
    offlineFormPrefill: "",
    location: {
        name: "Turkey",
        code: "TR",
        dial_code: "+90",
        emoji: "🇹🇷",
    },
    countryPhoneInfos: [],
    visitorInteracted: false,
};

const getters = {
    isMinimized: (state) => {
        return state.minimized;
    },
    getSocket: (state) => () => {
        return state.current_socket;
    },
    getPageIndex(state) {
        return state.pageIndex;
    },
};

const mutations = {
    SET_OFFLINE_FORM_PREFILL(state, text) {
        state.offlineFormPrefill = typeof text === "string" ? text : "";
    },
    SET_TAB_VISIBILITY_STATE: (state, payload) => {
        log.info("SET_TAB_VISIBILITY_STATE", payload);
        state.tabVisible = payload;
        state.lastTabHiddenTS = Date.now();
    },
    [MINIMIZE](state, payload) {
        state.minimized = payload;
    },
    [AFTER_ACTIONS](state, payload) {
        state.showAfterActions = payload;
    },
    [RATING](state, payload) {
        state.showRating = payload;
    },
    [CLOSE_CHAT_CONFIRMATION](state, payload) {
        state.showCloseChatConfirmation = payload;
    },
    ["SET_CURRENT_HOST_URL"](state, payload) {
        state.currentHostUrl = payload;
    },
    ["SET_ZOOM_VALUE"](state, payload) {
        state.zoomValue = payload;
    },
    ["SET_MOBILE_VERSION"](state, payload) {
        state.mobileVersion = payload;
    },
    ["SET_SAFARI_MODE"](state, payload) {
        state.safari = payload;
    },
    ["SET_VC_MODE"](state, videoCallModeEnabled) {
        state.videoCallMode = videoCallModeEnabled;
    },
    ["SET_CURRENT_VC"](state, vc) {
        state.currentVC = vc;
    },
    ["SET_VC_DIALING"](state, isCalling) {
        state.videoCallDialing = isCalling;
    },
    SET_SOCKET: (state, socket) => {
        log.debug("SET_SOCKET called", { socket });
        state.current_socket = socket;
    },
    SET_VOLUME(state, payload) {
        state.volume = parseInt(payload);
    },
    SET_VISITING_PAGE(state, page) {
        state.visitingPage = page;
    },
    CHANGE_PAGE(state, page) {
        state.lastPageIndex.push(state.pageIndex);
        state.pageIndex = page;
    },
    GO_PREV_PAGE(state) {
        state.pageIndex = state.lastPageIndex[state.lastPageIndex.length - 1];
        state.lastPageIndex.pop();
    },
    SET_COUNTRY_PHONE_INFOS(state, data) {
        state.countryPhoneInfos = data;
    },
    SET_LOCATION(state, data) {
        state.location = data;
    },
    SET_VISITOR_INTERACTED(state){
        state.visitorInteracted = true;
    },
};

const actions = {
    updateVolume({ commit }, payload) {
        commit("SET_VOLUME", payload);
    },
    minimize({ commit }, payload) {
        log.debug("minimize", payload);
        commit(MINIMIZE, payload);
    },
    toggleAfterActions({ commit }, payload) {
        log.debug("toggleAfterActions", payload);
        commit(AFTER_ACTIONS, payload);
    },
    toggleRating({ commit }, payload) {
        log.debug("toggleRating", payload);
        commit(RATING, payload);
    },
    toggleCloseChatConfirmation({ state, commit }, payload) {
        log.debug("toggleCloseChatConfirmation", payload);
        commit(CLOSE_CHAT_CONFIRMATION, payload);
    },
    setCurrentHostUrl({ state, commit }, payload) {
        log.debug("setCurrentHostUrl", payload);
        commit("SET_CURRENT_HOST_URL", payload);
    },
    setZoomValue({ state, commit }, payload) {
        log.debug("setZoomValue", payload);
        commit("SET_ZOOM_VALUE", payload);
    },
    setMobileVersion({ state, commit }, payload) {
        log.debug("setZoomValue", payload);
        commit("SET_MOBILE_VERSION", payload);
    },
    setSafariMode({ state, commit }, payload) {
        log.debug("setSafariMode", payload);
        commit("SET_SAFARI_MODE", payload);
    },
    setVideoCallMode({ state, commit }, videoCallModeEnabled) {
        log.debug("setVideoCallMode", videoCallModeEnabled);
        commit("SET_VC_MODE", videoCallModeEnabled);
    },
    setVideoCall({ state, commit }, vc) {
        log.debug("setVideoCall", vc);
        commit("SET_CURRENT_VC", vc);
    },
    setCalling({ state, commit }, calling) {
        log.debug("setCalling", calling);
        commit("SET_VC_DIALING", calling);
    },
    setSocket({ commit }, socket) {
        commit("SET_SOCKET", socket);
    },
    changeTabVisibilityChange({ commit }, payload) {
        return commit("SET_TAB_VISIBILITY_STATE", payload.visible);
    },
    setVisitingPage({ commit }, page) {
        return commit("SET_VISITING_PAGE", page);
    },
    setLocation({ commit }, data) {
        if (data) {
            commit("SET_LOCATION", data);
        }
    },
    getCountryPhoneInfos({ commit }) {
        getCountryPhoneInfos().then((data) => {
            commit("SET_COUNTRY_PHONE_INFOS", data);
        });
    },
    setVisitorInteracted({ commit }) {
        return commit("SET_VISITOR_INTERACTED");
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js